import { create } from 'zustand';

interface Toast { id: number; text: string; kind: 'info' | 'ok' | 'err' }
const useToasts = create<{ list: Toast[] }>(() => ({ list: [] }));
let n = 0;
export function toast(text: string, kind: Toast['kind'] = 'info', ms = 4500) {
  const id = ++n;
  useToasts.setState((s) => ({ list: [...s.list, { id, text, kind }] }));
  setTimeout(() => useToasts.setState((s) => ({ list: s.list.filter((t) => t.id !== id) })), kind === 'err' ? ms * 2 : ms);
}
export function Toasts() {
  const list = useToasts((s) => s.list);
  return (
    <div className="toasts" role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`toast ${t.kind}`}>
          <span className="grow">{t.text}</span>
          <button className="btn ghost sm" style={{ color: '#fff' }} aria-label="Dismiss" onClick={() => useToasts.setState((s) => ({ list: s.list.filter((x) => x.id !== t.id) }))}>✕</button>
        </div>
      ))}
    </div>
  );
}
